module.exports = __webpack_public_path__ + "img/fiturDonasi.b40e0fa7.png";